<template>
  <div class="wrapper">
    <div style="min-height: 100vh">
      <HeaderPanel :collapsed="sidebarCollapsed" @handle-toggle-sidebar="handleToggleSidebar"/>
      <div class="flex relative">
        <Sidebar/>
        <SidebarDrawer :collapsed="sidebarCollapsed" @toggle="handleToggleSidebar"/>
        <div class="main-wrapper md:w-[calc(100%-110px)] md:min-w-0 w-full min-w-full">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <GlobalLoaderIndicator/>
  </div>
</template>

<script>
import Sidebar from '@/components/layout/Sidebar'
import HeaderPanel from "@/components/layout/HeaderPanel";
import GlobalLoaderIndicator from "@/components/ui/GlobalLoaderIndicator.vue"
import SidebarDrawer from "@/components/layout/SidebarDrawer.vue";

export default {
  components: {
    SidebarDrawer,
    HeaderPanel,
    Sidebar,
    GlobalLoaderIndicator
  },
  data() {
    return {
      sidebarCollapsed: false
    }
  },
  methods: {
    handleToggleSidebar(value) {
      this.sidebarCollapsed = value ?? !this.sidebarCollapsed
    }
  }
}
</script>
